var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGraduate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    fill: "none",
    role: "img",
    "aria-label": "Graduation cap",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00C6EA",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 30.5 36 18l26 12.5L36 43 10 30.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 35.5v11.5c0 .8 7.2 7 16 7s16-6.2 16-7V35.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 30.5v16.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 49.5,
    r: 2.2,
    fill: "#00C6EA",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraduate);
export default __webpack_public_path__ + "static/media/icon-graduate.87ff83e1a3ad4ad6ba24928c7f0c98b4.svg";
export { ForwardRef as ReactComponent };